// utils/supabase/client.ts
// utils/supabase/client.ts (FIXED VERSION)
import { createBrowserClient } from '@supabase/ssr'

// Create a singleton instance to avoid multiple clients
let supabaseClient: ReturnType<typeof createBrowserClient> | null = null;

export function createClient() {
  // Return existing instance if already created
  if (supabaseClient) {
    return supabaseClient;
  }

  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  console.log('[utils/supabase/client.ts] Creating new Supabase client.');
  console.log(`  -> NEXT_PUBLIC_SUPABASE_URL: ${supabaseUrl ? 'Exists' : 'MISSING!'}`);
  console.log(`  -> NEXT_PUBLIC_SUPABASE_ANON_KEY: ${supabaseAnonKey ? 'Exists' : 'MISSING!'}`);

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('[utils/supabase/client.ts] Missing environment variables!');
    throw new Error('Missing Supabase environment variables');
  }

  try {
    // Create client with enhanced session management
    supabaseClient = createBrowserClient(
      supabaseUrl,
      supabaseAnonKey,
      {
        auth: {
          // Automatically refresh tokens before they expire
          autoRefreshToken: true,
          // Persist session in local storage (not just session storage)
          // This means users stay logged in even after closing browser
          persistSession: true,
          // Detect session in URL (for OAuth callbacks, magic links)
          detectSessionInUrl: true,
          // Store session for 30 days by default (Supabase default is 1 hour access + 7 days refresh)
          // The refresh token will automatically get new access tokens
          flowType: 'pkce', // More secure OAuth flow
        },
        // Configure cookies for better session persistence
        cookieOptions: {
          // Session lasts 30 days
          maxAge: 60 * 60 * 24 * 30, // 30 days in seconds
          // Allow cookies in iframes (for embedded content)
          sameSite: 'lax',
          // Secure in production
          secure: process.env.NODE_ENV === 'production',
        },
      }
    );

    // Verify client has required methods
    if (!supabaseClient || typeof supabaseClient.from !== 'function') {
      console.error('[utils/supabase/client.ts] Invalid client created!');
      throw new Error('Invalid Supabase client');
    }

    // Set up automatic session refresh listener
    // This ensures the session is refreshed in the background
    supabaseClient.auth.onAuthStateChange((event: string, session: unknown) => {
      if (event === 'TOKEN_REFRESHED') {
        console.log('[Supabase Client] Session token refreshed automatically');
      } else if (event === 'SIGNED_OUT') {
        console.log('[Supabase Client] User signed out');
      } else if (event === 'SIGNED_IN') {
        console.log('[Supabase Client] User signed in');
      }
    });

    return supabaseClient;
  } catch (error) {
    console.error('[utils/supabase/client.ts] Error creating client:', error);
    throw error;
  }
}

